export default __webpack_public_path__ + "static/media/me.6e3fd801.jpg";